import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Upload, Image, Select } from "antd";
import { ShoppingCartOutlined, GlobalOutlined, CloudUploadOutlined, DeleteOutlined } from "@ant-design/icons";
import "./onboard.css";
import InspectionConfiguration from "./InspectionConfiguration";
import APIEndpoint from "./APIEndpoint";
import PricingDetails from "./PricingDetails";
import BillingPopup from "./Billing";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Checkbox from '@mui/material/Checkbox';

import { inspectionConfigActions } from '../../Store/onboard/inspectionConfigSlice'
const Onboard = () => {
    const validatePassword = (password) => {
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return passwordPattern.test(password);
    };
    const [organizationName, setOrganizationName] = useState("");
    const [organizationAdminUserName, setOrganizationAdminUserName] = useState("");
    const [organizationProgramName, setOrganizationProgramName] = useState();
    const [organizationEmail, setOrganizationEmail] = useState("");
    const [dealerCode, setDealerCode] = useState([])
    const [dealerCodeInput, setDealerCodeInput] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [organizationId, setOrganizationId] = useState("");
    const [isBillingPopupOpen, setIsBillingPopupOpen] = useState(false);
    const [activeSection, setActiveSection] = useState("details-section");
    const [file, setFile] = useState(null);

    // const { selectedItems, selectedMode, selectedCount } = useSelector(
    //   (state) => state.inspectionConfig
    // );
    const inspectionConfig = useSelector((state) => state.inspectionConfigStore) || {};

    // Extract selected items with default values to prevent crashes
    // const { selectedItems = [], selectedMode = "Photo", selectedCount = 12, } = inspectionConfig;
    const {
        selectedItems = [],
        selectedMode = "Photo",
        selectedCount = 14,
        currentPlan = "Basic"
    } = useSelector((state) => state.inspectionConfigStore) || {};

    const dispatch = useDispatch(); // Initialize dispatch

    // Generate organizationId 
    useEffect(() => {
        const newOrganizationId = generateOrganizationId();
        setOrganizationId(newOrganizationId);
    }, []);
    // Function to auto-generate organization ID
    const generateOrganizationId = () => {
        const prefix = "AKSS";
        const randomNum = Math.floor(100000 + Math.random() * 900000); // Generates a 6-digit random number
        const year = new Date().getFullYear();
        return `${prefix}${randomNum}${year}`;
    };

    const [isCNGSelected, setIsCNGSelected] = useState(false);

    const handleInputChange = (type, e) => {
        const value = e.target.value;
        switch (type) {
            case "isCNGSelected":
                setIsCNGSelected(value);
                break;
            case "organizationName":
                setOrganizationName(value);
                break;
            case "organizationProgramName":
                setOrganizationProgramName(value);
                break;
            case "organizationAdminUserName":
                setOrganizationAdminUserName(value);
                break;
            case "organizationEmail":
                setOrganizationEmail(value);
                break;

            case "password":
                setPassword(value);
                break;
            case "confirmPassword":
                setConfirmPassword(value);
                break;
            default:
                break;
        }
    };
    const detailsRef = useRef(null);
    const inspectRef = useRef(null);
    const apiRef = useRef(null);
    const billingRef = useRef(null);
    const creditRef = useRef(null);
    useEffect(() => {
        const sectionRefs = [
            { id: "details-section", ref: detailsRef },
            { id: "inspect-section", ref: inspectRef },
            { id: "api-section", ref: apiRef },
            { id: "billing-section", ref: billingRef },
            { id: "credit-section", ref: creditRef },
        ];

        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5, // At least 50% of section visible
        };

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const matchedSection = sectionRefs.find(section => section.ref.current === entry.target);
                    if (matchedSection) {
                        setActiveSection(matchedSection.id);
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        sectionRefs.forEach((section) => {
            if (section.ref.current) {
                observer.observe(section.ref.current);
            }
        });

        return () => {
            sectionRefs.forEach((section) => {
                if (section.ref.current) {
                    observer.unobserve(section.ref.current);
                }
            });
        };
    }, []);

    const handleNavigation = (ref, sectionId) => {
        setActiveSection(sectionId);
        if (sectionId === "billing-section") {
            setIsBillingPopupOpen(true);
        }
        ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    };
const uploadLogoToS3 = async (fileObj, organizationId, organizationName) => {
  try {
    const file = fileObj?.FileList?.[0];
    if (!file) {
      console.error("No valid file found for upload.");
      return;
    }

    // ✅ Ensure safe org name
    const cleanOrgName = organizationName.replace(/[^a-zA-Z0-9-_]/g, "_");
    const fileName = `${organizationId}-${cleanOrgName}.jpeg`;

    // ✅ Convert file to Base64 safely
    const arrayBuffer = await file.arrayBuffer();
    const base64String = btoa(
      new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), "")
    );

    // ✅ Upload to backend → S3
    const response = await axios.post("/auth/upload-file", {
      blobName: `Insurance_Inspection/organization-logos/${fileName}`,
      fileContent: base64String,
      contentType: file.type || "image/jpeg",
    });

    if (response.status === 200) {
      console.log("✅ Logo uploaded successfully to S3:", response.data.url);

      const uploadStatus = {
        image_name: fileName,
        status: 1,
        type: "s3_logo_upload_status",
      };
      // dispatch(set_image_upload_status(uploadStatus)); // If Redux is used
    } else {
      console.error("❌ Upload failed with status:", response.status, response.data);
    }
  } catch (error) {
    console.error("Error uploading logo to S3:", error.message);
  }
};



    const handleImage = async (info) => {
        console.log("File selected: ", info);
        // const file = info.fileList[0].originFileObj;


        // Ensure a file is selected
        if (!info) {
            console.error("No file selected.");
            return;
        }

        // Call the Azure upload function
        try {
            await uploadLogoToS3(info, organizationId, organizationName);
            console.log("Logo uploaded successfully.");
        } catch (error) {
            console.error("Error during logo upload:", error);
        }
    };
    const handleLogo = async (info) => {
        console.log("File selected: ", info);
        const file = info.fileList[0].originFileObj;
        // Ensure a file is selected
        if (!file) {
            console.error("No file selected.");
            return;
        }
        // Set the selected file in state for preview
        setFile(info.fileList[0].originFileObj);
    };

    const handleRemoveImage = () => {
        setFile(null);
    };

    const isFormValid =
        organizationId &&
        organizationName &&
        // organizationProgramName &&
        organizationAdminUserName &&
        organizationEmail &&
        dealerCode &&
        password &&
        dealerCodeInput &&
        confirmPassword && file;
    console.log("check", isFormValid);

    // Fetch values from Redux
    const optVaahan = useSelector((state) => state.apiFormStore.optVaahan);
    const category = useSelector((state) => state.apiFormStore.category);

    const handleDealerCodeChange = (e) => {
        setDealerCodeInput(e.target.value);
    };
    const cleanedDealerCodes = dealerCodeInput
        .split(",")
        .map(code => code.trim())
        .filter(code => code); // remove empty strings

    console.log("Dealer codes array:", cleanedDealerCodes);
    const handleAddOrganization = async (orgDetails) => {
        if (!validatePassword(password)) {
            toast.error("Password must be at least 8 characters long, include an uppercase, lowercase, number, and special character.", {
                position: "bottom-left",
                autoClose: 3000,
            });
            return;
        }

        // Confirm password check
        if (password !== confirmPassword) {
            toast.error("Passwords do not match!", {
                position: "bottom-left",
                autoClose: 3000,
            });
            return;
        }

        try {
            const user = localStorage.getItem("insuranceUser");
            const user_info = JSON.parse(user);
            const token = user_info.token;

            // console.log("275", optVaahan, category, selectedItems, selectedCount, selectedMode);
            // console.log("222", dealerCode);


            const response = await axios.post(
                "/auth/add-organisation",
                {
                    ...orgDetails,
                    optVaahan, // Get from Redux
                    category, // Get from Redux
                    optCng: isCNGSelected,
                    inspectionConfig: {
                        selectedItems,
                        selectedMode,
                        selectedCount,
                    },
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 201) {
                if (file) {
                    await uploadLogoToS3(
                        { FileList: [file] },
                        orgDetails.organizationId,
                        orgDetails.organizationName
                    );
                    console.log("Logo uploaded after organization creation.");
                }
                console.log("Organization added successfully");
                dispatch(inspectionConfigActions.resetInspectionConfig());
                setOrganizationId(generateOrganizationId());
                setOrganizationProgramName()
                setOrganizationName("");
                setOrganizationAdminUserName("");
                setPassword("");
                setConfirmPassword("");
                setOrganizationEmail("");
                setDealerCode([])
                setDealerCodeInput("")
                setFile(null);
                setActiveSection("details-section");
                setIsCNGSelected(false)
                // Show success toast
                toast.success("Organization added successfully!", {
                    position: "bottom-left",
                    autoClose: 3000, // Closes after 3 seconds
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        } catch (error) {
            console.error("Error adding organization:", error);

            // Show error toast
            toast.error("Failed to add organization!", {
                position: "bottom-left",
                autoClose: 3000,
            });
        }
    };


    return (
        <div style={{ backgroundColor: 'white', height: "100vh", display: "flex", flexDirection: "column" }}>
            {/* Header */}
            <ToastContainer />
            <div className="header-onboard">
                <div className="header-add-onboard">
                    <div className="organisation-icon-onboard">
                        <GlobalOutlined />
                    </div>
                    <div className="header-text-onboard">
                        <h2 className="title">Add Organisation</h2>
                        <p className="subtitle">Add new organisation</p>
                    </div>
                </div>
                <div className="header-actions-onboard">
                    <Button
                        className="add-organization-button"
                        onClick={() =>
                            handleAddOrganization({
                                organizationId,
                                organizationName,
                                organizationProgramName,
                                organizationAdminUserName,
                                organizationEmail,
                                dealerCode: cleanedDealerCodes,
                                password,
                            })
                        }
                        disabled={!isFormValid} // Button stays disabled until form is valid
                    >
                        Add Organisation
                    </Button>

                </div>
            </div>

            {/* Sidebar and Main Content */}
            <div className="app-container-onboard">
                {/* Sidebar */}
                <div className="sidebar-onboard">
                    <ul className="sidebar-menu-onboard">
                        <li onClick={() => handleNavigation(detailsRef, "details-section")}>
                            <a style={{ color: activeSection === "details-section" ? "#ff0083" : "rgba(158, 158, 158, 1)" }}>Details</a>
                        </li>
                        <li onClick={() => handleNavigation(inspectRef, "inspect-section")}>
                            <a style={{ color: activeSection === "inspect-section" ? "#ff0083" : "rgba(158, 158, 158, 1)" }}>Inspect</a>
                        </li>
                        <li onClick={() => handleNavigation(apiRef, "api-section")}>
                            <a style={{ color: activeSection === "api-section" ? "#ff0083" : "rgba(158, 158, 158, 1)" }}>API</a>
                        </li>
                        <li onClick={() => handleNavigation(billingRef, "billing-section")}>
                            <a style={{ color: activeSection === "billing-section" ? "#ff0083" : "rgba(158, 158, 158, 1)" }}>Billing</a>
                        </li>
                        <li onClick={() => handleNavigation(creditRef, "credit-section")}>
                            <a style={{ color: activeSection === "credit-section" ? "#ff0083" : "rgba(158, 158, 158, 1)" }}>Credit</a>
                        </li>
                    </ul>
                </div>

                {/* Main Content */}
                <div className="scrollable-container">
                    {/* Details Section */}
                    <div id="details-section" ref={detailsRef} className="organization-details-section">
                        <div className="form-container">
                            <Form layout="vertical" className="form">
                                <h2 className="section-title">Organisation Details</h2>
                                <div className="form-grid">
                                    <Form.Item>
                                        <Input value={organizationId} readOnly />
                                    </Form.Item>
                                    {/* <Form.Item>
                                        <Select
                                            placeholder="Organisation Program Name"
                                            value={organizationProgramName}
                                            onChange={(value) => handleInputChange("organizationProgramName", { target: { value } })}
                                            options={[
                                                { label: 'Hyundai', value: 'Hyundai' },
                                                { label: "Surveyor's", value: "Surveyor's" },
                                                
                                            ]}
                                        />
                                    </Form.Item> */}

                                    <Form.Item>
                                        <Input
                                            placeholder="Organisation Admin Username"
                                            value={organizationAdminUserName}
                                            onChange={(e) => handleInputChange("organizationAdminUserName", e)}
                                        />
                                    </Form.Item>
                                    <Form.Item>
                                        <Input
                                            placeholder="Organisation Name"
                                            value={organizationName}
                                            onChange={(e) => handleInputChange("organizationName", e)}
                                        />
                                    </Form.Item>
                                    <Form.Item>
                                        <Input
                                            placeholder="Organisation Email"
                                            value={organizationEmail}
                                            onChange={(e) => handleInputChange("organizationEmail", e)}
                                        />
                                    </Form.Item>

                                    <Form.Item>
                                        <Input
                                            placeholder="Enter dealer codes (comma-separated)"
                                            value={dealerCodeInput}
                                            onChange={handleDealerCodeChange}
                                        />
                                    </Form.Item>

                                </div>
                                <div className="form-grid">
                                    <div className="upload-container">
                                        {!file ? (
                                            <Upload
                                                beforeUpload={() => false}
                                                onChange={handleLogo}
                                                showUploadList={false}
                                                className="upload-box"
                                            // disabled={!organizationName}
                                            >
                                                <div className="upload-content" >
                                                    <CloudUploadOutlined className="upload-icon" />
                                                    <p>Drag & Drop Logo</p>
                                                    <p>or</p>
                                                    <span>add file</span>
                                                </div>
                                            </Upload>
                                        ) : (
                                            <div className="uploaded-logo">
                                                <Image
                                                    src={URL.createObjectURL(file)}
                                                    alt="Logo"
                                                    style={{ width: "100px", height: "80px", objectFit: "contain" }}
                                                    preview={false}
                                                />
                                                <Button
                                                    icon={<DeleteOutlined />}
                                                    type="text"
                                                    onClick={handleRemoveImage}
                                                    // onClick={() => deleteImageFromAzure(organizationId, organizationName)}
                                                    style={{ color: "#ff4d4f", marginTop: "8px" }}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                    <div className="form-column">

                                        <Form.Item>
                                            <Input.Password
                                                placeholder="Enter your password"
                                                value={password}
                                                onChange={(e) => handleInputChange("password", e)}
                                            />
                                        </Form.Item>

                                        <Form.Item>
                                            <Input.Password
                                                placeholder="Repeat Password"
                                                value={confirmPassword}
                                                onChange={(e) => handleInputChange("confirmPassword", e)}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>

                    {/* Other Sections */}
                    <div ref={inspectRef} id="inspect-section"><InspectionConfiguration /></div>
                    <div style={{
                        background: '#fff',
                        padding: '12px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        margin: 'auto',
                        marginTop: '30px',
                        maxWidth: '800px'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{ fontSize: '16px', fontWeight: 500, color: '#333' }}>
                                Opt for CNG in Standard Plan
                            </div>
                            <Checkbox
                                checked={isCNGSelected}
                                onChange={(e) => handleInputChange("isCNGSelected", { target: { value: e.target.checked } })}
                                style={{
                                    transform: 'scale(1.2)',
                                    color: '#ff0083',
                                    '&.Mui-checked': {
                                        color: '#ff0083',
                                    },
                                }}
                            >
                                Enable CNG
                            </Checkbox>
                        </div>
                    </div>
                    <div ref={apiRef} id="api-section"><APIEndpoint organizationId={organizationId} /></div>
                    <div ref={creditRef} id="credit-section"><PricingDetails /></div>
                </div>
            </div>

            {/* Billing Popup */}
            <BillingPopup
                open={isBillingPopupOpen}
                onClose={() => {
                    setIsBillingPopupOpen(false)

                }}

                onSubmit={() =>
                    handleAddOrganization({
                        organizationId,
                        organizationProgramName,
                        organizationName,
                        organizationAdminUserName,
                        password,
                        organizationEmail,
                        dealerCode: cleanedDealerCodes,
                    })
                }
                handleImage={handleImage}
                file={file}
            />
        </div>
    );

};

export default Onboard;
